import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DomHandler } from 'primeng/dom';
import { Editor } from 'primeng/editor';
import { OverlayPanel } from 'primeng/overlaypanel';
import { LocalizationService } from 'src/app/modules/shared/services/localization.service';
import { PageLayoutService } from '../../services/page-layout.service';

@Component({
  selector: 'section-title',
  templateUrl: './section-title.component.html',
  styleUrls: ['./section-title.component.css']
})
export class SectionTitleComponent implements AfterViewInit {

  @Input() contentKey = '';
  @Input() admin = false;
  @Input() viewId = '';
  @Input() module = '';
  @Input() permissionLevel = '';
  @Input() permissionValue = '';
  @ViewChild('op') adminUpdatePanel: OverlayPanel;
  @ViewChild('FieldLabelContent') fieldLabelContent: Editor;
  @ViewChild('title') titleControl: ElementRef;
  sectionContent = '';
  defaultContent = '';
  interactionObserver: IntersectionObserver;

  constructor(private pageLayoutService: PageLayoutService, private localizationService: LocalizationService,
    private messageService: MessageService) { }

  ngAfterViewInit(): void {
    if (this.admin) {
      this.interactionObserver = new IntersectionObserver(this.onIntersection, {
        root: null,   // default is the viewport
        threshold: .65 // percentage of taregt's visible area. Triggers "onIntersection"
      });

      if (this.contentKey !== '') {
        this.localizationService.getDefaultLabelByKey(this.contentKey).subscribe(resp => this.defaultContent = resp, err => {
          console.log(err);
          this.messageService.add({
            severity: 'error',
            summary: err,
            closable: false
          });
        });
      }

      this.interactionObserver.observe(this.adminUpdatePanel.el.nativeElement);
    }
    this.getContentFromDb();

  }

  getContentFromDb() {
    if (this.contentKey !== '') {
      this.localizationService.getHtmlText(this.contentKey, this.module).subscribe(resp => {
        this.sectionContent = resp;
      }, err => {
        console.log(err);
        this.messageService.add({
          severity: 'error',
          summary: err,
          closable: false
        });
      });
    }
  }

  adminSelection() {
    if (this.admin) {
      const hostedDiv = this.titleControl.nativeElement;
      hostedDiv.insertAdjacentElement('afterend', this.adminUpdatePanel.el.nativeElement);
      if (!this.adminUpdatePanel.container) {
        this.adminUpdatePanel.container = this.adminUpdatePanel.el.nativeElement.firstElementChild;
      }
      this.adminUpdatePanel.show(this.titleControl.nativeElement, hostedDiv);

      if (this.adminUpdatePanel.el.nativeElement && this.adminUpdatePanel.el.nativeElement.classList.contains('admin-panel-flip')) {
        if (!this.adminUpdatePanel.container) {
          this.adminUpdatePanel.container = this.adminUpdatePanel.el.nativeElement.firstElementChild;
        }
        DomHandler.addClass(this.adminUpdatePanel.container, 'p-overlaypanel-flipped');
        const elementDimensions = this.adminUpdatePanel.container.offsetParent ?
          { width: this.adminUpdatePanel.container.offsetWidth, height: this.adminUpdatePanel.container.offsetHeight } :
          DomHandler.getHiddenElementDimensions(this.adminUpdatePanel.container);

        let top = hostedDiv.getBoundingClientRect().top + DomHandler.getWindowScrollTop() - elementDimensions.height;
        this.adminUpdatePanel.container.style.transformOrigin = 'bottom';

        if (top < 0) {
          top = DomHandler.getWindowScrollTop();
        }
        this.adminUpdatePanel.container.style.top = top + 'px';

      } else {
        this.adminUpdatePanel.align();
      }
    }
  }

  // callback is called on intersection change
  onIntersection(entries: Array<IntersectionObserverEntry>, opts: IntersectionObserver) {
    entries.forEach(entry =>
      entry.target.classList.toggle('admin-panel-flip', entry.isIntersecting)
    );
  }

  submitAdminContentUpdate() {
    this.pageLayoutService.saveUpdatedSection(this.sectionContent
      , this.contentKey, this.viewId, this.module, this.permissionLevel, this.permissionValue)
      .subscribe(res => {
        this.adminUpdatePanel.hide();
        this.getContentFromDb();
      });
  }

}
